<script setup>
import { ref, reactive, computed, onMounted, defineComponent } from 'vue'
import { showToast, } from 'vant';
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getRemarkInfoAPI, } from '@/util/api'

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
const remarkInfo = ref('')

const getRemarkInfo = () => {
  getRemarkInfoAPI().then(res => {
    if (res.data.code == 0) {
      remarkInfo.value = res.data.data
      console.log('【remarkInfo】', remarkInfo);
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const goCustomer = () => {
  if (localStorage.getItem('config-record')) {
    window.location.href = JSON.parse(localStorage.getItem('config-record')).download[2].value
  }
}

onMounted(() => {
  getRemarkInfo()
})
</script>

<template>
  <section class="trade-box">
    <aside style="margin-top: 0.76rem; display: flex; align-items: center; width: 356px;">
      <img src="@/assets/img/03p/account-icon.png" alt="" style="height: 0.18rem; margin-left: 8px;">
    </aside>
    <aside class="text-box" v-html="remarkInfo.REMARK"></aside>
    <aside style="width: 356px; display: flex; justify-content: flex-end; align-items: center; margin-top: 0.14rem;">
      <img @click="goCustomer" src="@/assets/img/04p/help02.png" alt="" style="height: 0.14rem;">
    </aside>
  </section>
</template>

<style scoped>
.trade-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/03p/trade-bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-sys2 {
  font-size: 15px;
  /* font-weight: bolder; */
  color: #ffffff;
  text-shadow: -1px -1px 0 rgb(67, 116, 167), 1px -1px 0 rgb(67, 116, 167), -1px 1px 0 rgb(67, 116, 167), 1px 1px 0 rgb(67, 116, 167);
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
table, thead, td {
  font-size: 14px;
  border: 1px solid rgb(146, 176, 206);
  border-collapse: collapse;
}
table {
  width: 100%;
  border-radius: 8px;
}
tr {
  height: 36px;
}
td {
  text-align: center;
}
.time-text {
  font-size: 13px;
  color: rgb(67, 116, 167);
  padding: 0px 6px;
}
.time-text-no {
  font-size: 13px;
  color: #cdcdcd;
  padding: 0px 6px;
}
.text-box {
  width: 332px;
  padding: 12px 16px;
  border-radius: 10px;
  background: rgb(255 255 255 / 50%);
  font-size: 13px;
  color: rgb(67, 116, 167);
  margin-top: 24px;
  line-height: 1.5;
  max-height: 4.4rem;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
